import { TodoColumn } from "../../../../types/TodoTypes";

export const resolveColumnId = (
  taskColumnId: string | undefined,
  columns: TodoColumn[]
): string => {
  if (taskColumnId && columns.some((c) => c.id === taskColumnId))
    return taskColumnId;
  return columns[0]?.id ?? "";
};

export const isHtmlEmpty = (html: string | undefined | null): boolean => {
  if (!html) return true;
  return (
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim().length === 0
  );
};

export const htmlToText = (html: string | undefined | null): string => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ");
};
